import styles from './tax.module.scss'
import React, { useState, useEffect, useRef } from 'react'
import moment from 'moment'
import { compare } from 'utils'

//components
import TitlePage from 'components/title-page'
import FilterDate from 'components/filter-date'

//antd
import {
  Switch,
  InputNumber,
  Input,
  Button,
  notification,
  Table,
  Row,
  Form,
  Col,
  Drawer,
  Checkbox,
  Popconfirm,
  Select,
} from 'antd'
import { getCountries } from 'apis/country'
//icons
import { PlusCircleOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons'

//apis
import { addTax, getTaxList, updateTax, deleteTax } from 'apis/tax'

const { TextArea } = Input
export default function Tax() {
  const [form] = Form.useForm()

  const [taxList, setTaxList] = useState([])
  const [visible, setVisible] = useState(false)
  const [loading, setLoading] = useState(false)
  const [taxUpdate, setTaxUpdate] = useState(null)
  const [paramsFilter, setParamsFilter] = useState({ page: 1, page_size: 20 })
  const [countTax, setCountTax] = useState(0)
  const [countries, setCountries] = useState([])

  const showDrawer = () => {
    setVisible(true)
  }

  const onClose = () => {
    setVisible(false)
    setTaxUpdate(null)
  }

  const typingTimeoutRef = useRef(null)
  const [valueSearch, setValueSearch] = useState('')
  const onSearch = (e) => {
    setValueSearch(e.target.value)
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current)
    }
    typingTimeoutRef.current = setTimeout(() => {
      const value = e.target.value
      if (value) paramsFilter.name = value
      else delete paramsFilter.name
      setParamsFilter({ ...paramsFilter })
    }, 650)
  }

  const _getTaxList = async () => {
    try {
      setLoading(true)
      const res = await getTaxList(paramsFilter)
      if (res.status === 200) {
        setTaxList(res.data.data)
        setCountTax(res.data.count)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const _addOrEditTax = async () => {
    try {
      await form.validateFields()
      const dataForm = form.getFieldsValue()
      console.log(dataForm)
      const body = {
        ...dataForm,
        description: dataForm.description || '',
        is_default: dataForm.is_default || false,
      }
      setLoading(true)

      let res
      if (taxUpdate) res = await updateTax(body, taxUpdate.tax_id)
      else res = await addTax(body)
      console.log(res)
      setLoading(false)
      if (res.status === 200) {
        if (res.data.success) {
          notification.success({ message: `${taxUpdate ? 'Cập nhật' : 'Thêm'} thuế thành công` })
          _getTaxList()
          onClose()
          form.resetFields()
        } else
          notification.error({
            message:
              res.data.message ||
              `${taxUpdate ? 'Cập nhật' : 'Thêm'} thuế thất bại, vui lòng thử lại`,
          })
      } else
        notification.error({
          message:
            res.data.message ||
            `${taxUpdate ? 'Cập nhật' : 'Thêm'} thuế thất bại, vui lòng thử lại`,
        })
    } catch (error) {
      setLoading(false)
    }
  }

  const _deleteTax = async (id) => {
    try {
      setLoading(true)

      const res = await deleteTax([id])
      if (res.status === 200) {
        if (res.data.success) {
          notification.success({ message: 'Xóa thuế thành công' })
          _getTaxList()
        } else
          notification.error({ message: res.data.message || 'Xóa thuế thất bại, vui lòng thử lại' })
      } else
        notification.error({ message: res.data.message || 'Xóa thuế thất bại, vui lòng thử lại' })

      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const _getCountries = async () => {
    try {
      const res = await getCountries()
      if (res.status === 200) setCountries(res.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  const _updateTax = async (body, id) => {
    try {
      setLoading(true)
      const res = await updateTax(body, id)
      setLoading(false)
      if (res.status === 200) {
        if (res.data.success) {
          _getTaxList()
          notification.success({ message: 'Cập nhật thành công' })
        } else
          notification.error({ message: res.data.message || 'Cập nhật thất bại, vui lòng thử lại' })
      } else
        notification.error({ message: res.data.message || 'Cập nhật thất bại, vui lòng thử lại' })
    } catch (error) {
      setLoading(false)
    }
  }

  const columns = [
    {
      width: 60,
      title: 'STT',
      render: (text, record, index) => (paramsFilter.page - 1) * paramsFilter.page_size + index + 1,
    },
    {
      title: 'Quốc gia',
      dataIndex: 'country_info',
      render(data, record, index) {
        return <div>{record.country_info && record.country_info.name}</div>
      },
    },
    {
      title: 'Thuế trong giá bán',
      render(data, record, index) {
        return <div>{record.is_apply_product == true ? 'Có' : 'Không'}</div>
      },
    },
    {
      title: 'Tên thuế',
      dataIndex: 'name',
      sorter: (a, b) => compare(a, b, 'name'),
      render: (text, record) => (
        <a
          onClick={() => {
            setVisible(true)
            setTaxUpdate(record)
            form.setFieldsValue({ ...record })
          }}
        >
          {text} {record.is_default && '(Mặc định)'}
        </a>
      ),
    },

    {
      title: 'Giá trị',
      dataIndex: 'value',
      render: (text, record) => text && `${text}%`,
      sorter: (a, b) => compare(a, b, 'value'),
    },
    {
      title: 'Mô tả',
      dataIndex: 'description',
      sorter: (a, b) => compare(a, b, 'description'),
    },
    {
      title: 'Ngày tạo',
      render: (text, record) =>
        record.create_date && moment(record.create_date).format('DD/MM/YYYY HH:mm'),
    },
    {
      width: 100,
      title: 'Trạng thái',
      dataIndex: 'is_active',
      render: (text, record) => (
        <Switch
          checked={record.is_active}
          onChange={() => _updateTax({ is_active: !record.is_active }, record.tax_id)}
        />
      ),
    },
    {
      width: 100,
      title: 'Hành động',
      render: (text, record) => (
        <Popconfirm
          title="Bạn có muốn xóa thuế này không?"
          onConfirm={() => _deleteTax(record.tax_id)}
        >
          <DeleteOutlined style={{ color: 'red', cursor: 'pointer', fontSize: 19 }} />
        </Popconfirm>
      ),
    },
  ]

  useEffect(() => {
    _getTaxList()
  }, [paramsFilter])

  useEffect(() => {
    _getCountries()
  }, [])

  return (
    <>
      <div className={`${styles['supplier_manager']} ${styles['card']}`}>
        <TitlePage title="Quản lý thuế">
          <Button onClick={showDrawer} size="large" type="primary" icon={<PlusCircleOutlined />}>
            Thêm thuế
          </Button>
        </TitlePage>

        <Row gutter={[16, 16]} style={{ marginTop: 20, marginBottom: 20 }}>
          <Col xs={24} sm={24} md={11} lg={11} xl={9}>
            <Input
              prefix={<SearchOutlined />}
              size="large"
              style={{ width: '100%' }}
              value={valueSearch}
              onChange={onSearch}
              placeholder="Tìm kiếm theo tên thuế"
              allowClear
            />
          </Col>
          <Col xs={24} sm={24} md={11} lg={11} xl={6}>
            <FilterDate
              size="large"
              paramsFilter={paramsFilter}
              setParamsFilter={setParamsFilter}
            />
          </Col>
        </Row>

        <div style={{ width: '100%', border: '1px solid rgb(243, 234, 234)' }}>
          <Table
            size="small"
            columns={columns}
            loading={loading}
            dataSource={taxList}
            style={{ width: '100%' }}
            pagination={{
              position: ['bottomLeft'],
              current: paramsFilter.page,
              defaultPageSize: 20,
              pageSizeOptions: [20, 30, 40, 50, 60, 70, 80, 90, 100],
              showQuickJumper: true,
              onChange: (page, pageSize) =>
                setParamsFilter({ ...paramsFilter, page: page, page_size: pageSize }),
              total: countTax,
            }}
          />
        </div>
      </div>
      <Drawer
        footer={
          <Row justify="end">
            <Button
              loading={loading}
              style={{ minWidth: 100 }}
              size="large"
              type="primary"
              onClick={_addOrEditTax}
            >
              {taxUpdate ? 'Cập nhật' : 'Thêm'}
            </Button>
          </Row>
        }
        title={taxUpdate ? 'Cập nhật thuế' : 'Thêm thuế'}
        width={720}
        onClose={onClose}
        visible={visible}
      >
        <Form layout="vertical" form={form}>
          <Row justify="space-between">
            <Col xs={24} sm={24} md={11} lg={11} xl={11}>
              <Form.Item
                name="country_id"
                label="Quốc gia"
                rules={[{ required: true, message: 'Vui lòng chọn quốc gia' }]}
              >
                <Select placeholder="Chọn quốc gia" optionFilterProp="children" showSearch>
                  {countries.map((country, index) => (
                    <Select.Option value={country.country_id} key={index}>
                      {country.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Tên thuế"
                name="name"
                rules={[{ required: true, message: 'Vui lòng nhập tên thuế' }]}
              >
                <Input placeholder="Nhập tên thuế" size="large" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={11} lg={11} xl={11}>
              <Form.Item
                label="Giá trị (%)"
                name="value"
                rules={[{ required: true, message: 'Vui lòng nhập giá trị' }]}
              >
                <InputNumber
                  placeholder="Nhập giá trị (%)"
                  size="large"
                  className="br-15__input"
                  style={{ width: '100%' }}
                  min={0}
                  max={100}
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item label="Mô tả" name="description">
                <TextArea rows={4} placeholder="Nhập mô tả" />
              </Form.Item>
            </Col>
          </Row>
          <Row justify="space-between">
            <Form.Item name="is_default" valuePropName="checked">
              <Checkbox>Chọn làm thuế mặc định</Checkbox>
            </Form.Item>

            <Form.Item name="is_apply_product" valuePropName="checked">
              <Checkbox>Thuế đã tính vào giá bán sản phẩm</Checkbox>
            </Form.Item>

            <Form.Item name="is_apply_order" valuePropName="checked">
              <Checkbox defaultChecked={true}>Thuế áp dụng cho đơn hàng</Checkbox>
            </Form.Item>
          </Row>
        </Form>
      </Drawer>
    </>
  )
}
